import { setTargetEntityPropertiesFromSourceEntityArray } from '../siloRelated/setTargetEntityPropertiesFromSourceEntityArray'
import { TeamMember } from './TeamMember'
import type {
  IOpportunityTeamMember,
  IOpportunityOverview,
} from '~/types/opportunity/models'

const mn = '[cynqueModules/dataObjects/OpportunityTeamMembers.ts]'

export function OpportunityTeamMember(
  o: IOpportunityTeamMember
): IOpportunityTeamMember {
  const fn =
    '[cynqueModules/dataObjects/OpportunityTeamMember.ts] OpportunityTeamMember |'
  if (!o) {
    throw new Error(
      `${fn} OpportunityTeamMember called with falsey companyTeamMember`
    )
  }
  if (!o.teamMember) {
    throw new Error(
      `${fn} OpportunityTeamMember called with falsey companyTeamMemmber.teamMember`
    )
  }

  const obj = { ...o }

  obj.teamMember = TeamMember(obj.teamMember)
  obj.label = obj.teamMember.label
  return obj
}

// Propagators

export function propagateOpportunityTeamMemberData({
  overviewData,
}: {
  overviewData: IOpportunityOverview
}) {
  //
  // embedded functions
  //
  function _propagateFromOpportunityTeamMembersToOpportunity({
    mn,
    overviewData,
  }: {
    mn: string
    overviewData: IOpportunityOverview
  }) {
    const fn = `${mn} _propagateFromOpportunityTeamMemberToOpportunity |`
    const { opportunity, opportunityTeamMembers } = overviewData
    setTargetEntityPropertiesFromSourceEntityArray({
      propertyNames: ['isOwner', 'isAssignedTo'],
      sourceEntityArray: opportunityTeamMembers,
      sourceEntitySelectItemIdPathString: 'teamMember.id',
      sourceEntitySelectItemLabelPathString: 'teamMember.label',
      targetEntity: opportunity,
    })
    console.debug(`${fn} overviewData after propagation:`, overviewData)
  }
  //
  // execution starts here...
  //
  const fn = `${mn} propagateOpportunityTeamMemberData |`
  console.debug(`${fn} called`)
  _propagateFromOpportunityTeamMembersToOpportunity({
    mn,
    overviewData,
  })
}
